import { render, staticRenderFns } from "./editReservationPage.vue?vue&type=template&id=38f08e2a&"
import script from "./editReservationPage.vue?vue&type=script&lang=js&"
export * from "./editReservationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports